<!-- passwordReset -->
<template>
  <div>
    <div v-show="!showK0008Dialog">
      <div class="modal-container-company" style="height:100%;overflow:auto; width:100%">
        <!-- Dialog标题 -->
        <div class="modal-header">
          <div style="width:50%; text-align:left">{{$t('MODULE.PASSWORDRESET_DIALOG_TITLE')}}</div>
          <div style="width:50%; padding-right:5px" align='right'>
            <el-button type="text" class="el-icon-close" style="color:white;" @click="back_click"></el-button>
          </div>
        </div>
        <!-- 文字 -->
        <div align='center' class="passwordReset_msg">
          <h1 class="passwordReset_msg5">{{$t('MODULE.PASSWORDRESET_MSG_MSG5')}}</h1>
          <p style="font-size:15px" v-html="$t('MODULE.PASSWORDRESET_MSG_MSG6')"></p>
          <p style="font-size:15px" v-html="$t('MODULE.PASSWORDRESET_MSG_MSG7')"></p>
          <p class="passwordReset_msg8" v-html="$t('MODULE.PASSWORDRESET_MSG_MSG8')"></p>
          <p style="font-size:15px" v-html="$t('MODULE.PASSWORDRESET_MSG_MSG9')"></p>
          <p style="font-size:15px" v-html="$t('MODULE.PASSWORDRESET_MSG_MSG10')"></p>
          <table class="passwordReset-table table-label">
            <!-- スタッフNO -->
            <tr>
              <td class="passwordReset-form-label" v-html="$t('MODULE.PASSWORDRESET_LBL_STAFF_NO')"></td>
              <td>
                <el-input v-model="staffNo" class="passwordReset_input" maxlength="8"></el-input>
              </td>
            </tr>
            <!-- 誕生日 -->
            <tr>
              <td class="passwordReset-form-label" v-html="$t('MODULE.PASSWORDRESET_LBL_BIRTHDAY')"></td>
              <td>
                <el-input v-model="birthday" class="passwordReset_input" maxlength="8"></el-input>
              </td>
            </tr>
            <!-- 電話番号/携帯番号 -->
            <tr>
              <td class="passwordReset-form-label" v-html="$t('MODULE.PASSWORDRESET_LBL_PHONE_NO')"></td>
              <td>
                <el-input v-model="phoneNo" class="passwordReset_input"></el-input>
              </td>
            </tr>
          </table>
        </div>
        <div>
          <!-- 送信 -->
          <el-button type="primary" class="css-button css-btn" style="margin-top:15px" @click="sendBtnClick">{{$t('MODULE.PASSWORDRESET_LBL_BACK')}}</el-button>
        </div>
        <div style="height:20px"></div>
      </div>
    </div>
    <div v-show="showK0008Dialog">
      <div class="modal-container-company" style="height:100%;overflow:auto; width:100%">
        <!-- Dialog标题 -->
        <div class="modal-header">
          <div style="width:50%;">{{$t('MODULE.K0008_LBL_TITTLE')}}</div>
          <div style="width:50%;padding-right:5px" align='right'>
            <el-button type="text" class="el-icon-close" style="color:white;" @click="back_click"></el-button>
          </div>
        </div>
        <K0008 style="height:50%"></K0008>
      </div>
    </div>
    <el-dialog class="codeCheck" :visible.sync="dialogVisible" :close-on-click-modal="false" width="70%" :modal="false" :center="true">
      <div style="line-height: 2">{{$t('MODULE.PASSWORDRESET_LBL_STAFF_NO_DIALOG')}}{{staffNo}}</div>
      <div style="line-height: 2">{{$t('MODULE.PASSWORDRESET_LBL_CONFIRM_DIALOG')}}</div>
      <el-input v-model="authenticationCode" class="passwordReset_input" style="margin-top:5px"></el-input>
      <span slot="footer">
        <el-button class="css-button css-btn" type="primary" @click="codeCheck">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

let url = require('@/../config/sysConfig')
import css from "@/statics/css"
import K0008 from '@/module/page/k_0008'
import * as amsApi from "../api/passwordResetDeliver"
export default {
  mixins: [css],
  props: {
    showK0008Dialog: {
      type: Boolean,
      default: false
    },
  },
  components: {
    "K0008": K0008
  },
  data() {
    return {
      staffNo: '',
      birthday: '',
      phoneNo: '',
      address: '',
      dialogVisible: false,
      authenticationCode: ''
    };
  },
  created() {

  },
  mounted() {

  },
  methods: {
    // 戻る処理
    back_click() {
      this.$emit('closePasswordResetDeliverDialog');
    },
    sendBtnClick() {
      let re = new RegExp(/^[0-9]{8}$/);
      //スタッフNo、生年月日、電話番号のいずれか入力していない場合、エラーメッセージ表示
      if (!this.staffNo) {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.PASSWORDRESET_LBL_STAFF_NO')), showClose: true });
        return
      }
      if (!this.birthday) {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.PASSWORDRESET_LBL_BIRTHDAY')), showClose: true });
        return
      }
      if (!this.phoneNo) {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.PASSWORDRESET_LBL_PHONE_NO')), showClose: true });
        return
      }
      //スタッフNoが8桁の数字で入力してください。
      if (!re.test(this.staffNo)) {
        this.$message.error({ message: this.$t('COMMON.MSG_STAFF_NO_VALIDITY'), showClose: true });
        return
      }
      //生年月日が8桁の数字で入力してください。
      if (!re.test(this.birthday)) {
        this.$message.error({ message: this.$t('COMMON.MSG_BIRTHDAY_VALIDITY'), showClose: true });
        return
      }
      this.userInfoSearch()
    },
    userInfoSearch() {
      this.set_loading()
      var params = {}
      params.userId = this.staffNo
      params.birthday = this.birthday
      params.phoneNo = this.phoneNo
      amsApi.passwordReset(params).then(res => {
        if (res.code == '434') {
          //該当スタッフNoが存在しません。
          this.$message.error({ message: this.$t('COMMON.MSG_STAFF_NOT_EXIST'), showClose: true });
        }
        //生年月日、或いは電話番号が不正です。
        else if (res.code == '439') {
          this.$message.error({ message: this.$t('COMMON.MSG_PWRESET_INFO_ERROR'), showClose: true });
        }
        //該当スタッフNoのメールアドレスが空白。
        else if (res.code == '440') {
          this.$message.error({ message: this.$t('COMMON.MSG_ADDRESS_EXIST'), showClose: true });
        }
        //成功
        else if (res.code == '204') {
          this.dialogVisible = true
        }
        // 権限がありません。
        else if (res.code == '436') {
          this.$message.error({ message: this.$t('COMMON.MSG_NO_AUTHORITY'), showClose: true });
        }
        this.close_loading()
      }).catch((err) => {
        this.close_loading()
      });
    },
    //認証コードチェック
    codeCheck() {
      let userCd = this.staffNo
      let verCode = this.authenticationCode
      amsApi.login_check(userCd, verCode).then(res => {
        if (res.code == '442') {
          this.$message.success({ message: this.$t('COMMON.MSG_TEMPCODE_OK'), showClose: true });
          this.$router.push({ name: 'ホーム', params: { pwResetForwardFlag: "1" } })
        } else if (res.code == '441') {
          this.$message.error({ message: this.$t('COMMON.MSG_TEMPCODE_ERROR'), showClose: true });
          return
        }
      }).catch(err => {
        this.$message.error({ message: this.$t('COMMON.MSG_TEMPCODE_ERROR'), showClose: true });
      });
    }

  },

};
</script>
<style scope>
/* 第一段文字样式 */
.passwordReset_msg5 {
  font-size: 20px;
}
/* 第二段文字样式 */
.passwordReset_msg8 {
  font-size: 15px;
  color: red;
}
.passwordReset_input .el-input__inner {
  width: 100%;
  font-size: 12px;
  padding: 0 12px 0 12px;
}
.passwordReset_msg h1 {
  margin: 15px 0;
}
/* 表格边框、字体样式 */
.passwordReset-table {
  border-collapse: collapse;
  width: 80%;
}
/* 表格边框颜色 */
.passwordReset-table,
.passwordReset-table tr td {
  line-height: 2;
  border: 1px solid #ccc;
  background: #f8f8f8;
}
/* 表格内边距 */
.passwordReset-table td {
  padding: 5px 8px;
}
/* 表格第一列背景色、宽度、文字居右 */
.passwordReset-form-label {
  text-align: right;
  width: 110px;
}
.codeCheck .el-dialog__body {
  padding-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/passwordResetDeliver.vue